var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCatalogueIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "catalogue 1",
    clipPath: "url(#clip0_607_1837)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M95 67.168V11.1328H47.5V78.3008L95 67.168Z",
    fill: "#4A75C3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M47.5 11.1328H0V67.168L47.5 78.3008V11.1328Z",
    fill: "#458FDE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M62.803 84.9589L60.9145 75.5176H36.3672V92.2168H68.261V89.4336C65.6168 89.4336 63.3214 87.5516 62.803 84.9589Z",
    fill: "#3D4E9C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M34.0853 75.5176L32.1968 84.9589C31.6784 87.5516 29.383 89.4336 26.7388 89.4336V92.2168H47.4998V75.5176H34.0853Z",
    fill: "#4362B0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M58.6328 0H83.8672V73.6621H25.0488L47.5 11.1328C47.5 5.00977 52.5098 0 58.6328 0Z",
    fill: "#BCDEF7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M57.2412 37.7588H74.126V58.8184H57.2412V37.7588Z",
    fill: "#2DB37F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M57.2412 11.1328H74.126V32.1924H57.2412V11.1328Z",
    fill: "#F15D4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M36.3672 0H11.1328V73.6621H47.5V11.1328C47.5 5.00977 42.4902 0 36.3672 0Z",
    fill: "#DDEFFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M83.8672 89.4336H47.5L41.9336 92.2168L47.5 95H83.8672V89.4336Z",
    fill: "#243870"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M11.1328 89.4336H47.5V95H11.1328V89.4336Z",
    fill: "#3D4E9C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M47.5 67.168L36.3672 74.126L47.5 81.084H95V67.168H47.5Z",
    fill: "#243870"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M0 67.168H47.5V81.084H0V67.168Z",
    fill: "#3D4E9C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M20.874 37.7588H37.7588V58.8184H20.874V37.7588Z",
    fill: "#6FAEE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M20.874 11.1328H37.7588V32.1924H20.874V11.1328Z",
    fill: "#FB9D46"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_607_1837"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95,
    height: 95,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogueIcon);
export default __webpack_public_path__ + "static/media/CatalogueIcon.ca46a9ace42052b2b67349b345ac5192.svg";
export { ForwardRef as ReactComponent };